import {
  ReadOnlySelectorFamilyOptions,
  ReadWriteSelectorFamilyOptions,
  RecoilState,
  RecoilValueReadOnly,
  selectorFamily,
  SerializableParam,
} from 'recoil';

export function recoilSelectorFamily<T, P extends SerializableParam>(
  options: ReadWriteSelectorFamilyOptions<T, P>,
): (param: P) => RecoilState<T>;

export function recoilSelectorFamily<T, P extends SerializableParam>(
  options: ReadOnlySelectorFamilyOptions<T, P>,
): (param: P) => RecoilValueReadOnly<T>;

export function recoilSelectorFamily<T, P extends SerializableParam>(
  options: ReadWriteSelectorFamilyOptions<T, P> | ReadOnlySelectorFamilyOptions<T, P>,
) {
  return selectorFamily<T, P>({
    cachePolicy_UNSTABLE: {
      // Only store the most recent set of dependencies and their values
      eviction: 'most-recent',
    },
    ...options,
  });
}
